<template>
  <div class="h-toolbarBg">
    <ejs-toolbar>
      <div>
        <div v-if='btns.add'>
          <button :title='$t("MCS.addUser")' class="e-tbar-btn e-control e-btn e-lib e-icon-btn" @click='buttonClk("addDP")' data-ripple="true" tabindex="-1" style="width: auto;">
            <span class="e-btn-icon icon hero-icon hero-icon-add e-icons"></span>
          </button>
        </div>
        <div v-if='btns.del'>
          <button :title='$t("MCS.del")' class="e-tbar-btn e-control e-btn e-lib e-icon-btn" @click='buttonClk("delDP")' data-ripple="true" tabindex="-1" style="width: auto;">
            <span class="e-btn-icon icon hero-icon hero-icon-batch-remove e-icons"></span>
          </button>
        </div>
        <div v-if='btns.deploy'>
          <button title='一键部署' class="e-tbar-btn e-control e-btn e-lib e-icon-btn" @click='buttonClk("deploy")' data-ripple="true" tabindex="-1" style="width: auto;">
            <span class="e-btn-icon icon hero-icon hero-icon-user e-icons"></span>
          </button>
        </div>
        <div v-if='btns.detail'>
        <button title='部署详情' class="e-tbar-btn e-control e-btn e-lib e-icon-btn" @click='buttonClk("detail")' data-ripple="true" tabindex="-1" style="width: auto;">
          <span class="e-btn-icon icon hero-icon hero-icon-detailed e-icons"></span>
        </button>
        </div>
        <div v-if='btns.export'>
          <button title='导出模板' class="e-tbar-btn e-control e-btn e-lib e-icon-btn" @click='buttonClk("export")' data-ripple="true" tabindex="-1" style="width: auto;">
            <span class="e-btn-icon icon hero-icon hero-icon-excel-export e-icons"></span>
          </button>
        </div>
      </div>
    </ejs-toolbar>
  </div>
</template>

<script>
export default {
  name: 'DPEnviromentTableMenu',
  data() {
    return {
      components: {

      },
      btns: {
        add: true,
        del: true,
        deploy: true,
        detail: true,
        export: true
      },
      queryConditions: {
        keywords: '' // 模糊查询关键字
      }
    };
  },
  methods: {
    buttonClk(args) {
      this.$emit('methodEnum', args);
    },
    updateKeywords() {
      this.$emit('keywords', this.queryConditions.keywords);
    },
    keydownFunc() {
      if (this.queryConditions.keywords === '') {
        this.queryConditions.keywords = '';
        this.$emit('methodEnum', 'qry');
      } else {
        this.$emit('methodEnum', 'detailQry');
      }
    }
  }
};
</script>

<style scoped>

</style>
